import { useRouter } from "next/router";
import { useEffect } from "react";
import { openAgencyEmailSignInModal } from "../../../../components/molecules/modals/ats/public-sign-in-modal.tsx/agency-email-sign-in-modal";
import { Switch } from "../../../../components/switch";
import useRouterVariable from "../../../../components/utils/useRouterVariable";

import {
  useFetchOrgAtsEnabled,
  useFetchOrgDisplayName,
  useFetchOrgLogoLinkv2,
} from "../../../api-docs";
import { AgencySelfApplySignInButton } from "../../agency/components/agency-sign-in-button";
import { CandidateSignInButton } from "../../candidate/components/candidate-sign-in-button";
import { HeaderLogo } from "../../components/header-logo";
import { Header } from "../../components/header/header";
import { NoJobAvailable } from "../../components/no-jobs-available/no-jobs-available";
import { NoSidebar } from "../../layouts/no-sidebar";
import { SELF_APPLY_USER_TYPE_ENUM } from "../../types/self-apply-user-type";

export const EmptySelfApplyHeader = (props: {
  userType?: SELF_APPLY_USER_TYPE_ENUM;
  showSignInButton?: boolean;
}) => {
  const orgName = useRouterVariable("org", (o) => o as string);
  const orgLogo = useFetchOrgLogoLinkv2(
    { orgFriendlyName: orgName },
    {
      query: {
        enabled: orgName != null,
      },
    },
  );
  const orgDisplayName = useFetchOrgDisplayName(
    { orgFriendlyName: orgName },
    {
      query: {
        enabled: orgName != null,
      },
    },
  );
  return (
    <Header
      leading={<HeaderLogo logo={orgLogo.data} />}
      content={
        <h1 className="flex items-center justify-center text-base font-medium leading-normal">
          {orgDisplayName.data ?? ""}
        </h1>
      }
      trailing={
        props.showSignInButton ? (
          <Switch.Container value={props.userType}>
            <Switch.Case value={SELF_APPLY_USER_TYPE_ENUM.AGENCY}>
              <div className="flex w-full flex-1 items-center justify-end">
                <AgencySelfApplySignInButton />
              </div>
            </Switch.Case>
            <Switch.Case value={SELF_APPLY_USER_TYPE_ENUM.CANDIDATE}>
              <div className="flex w-full flex-1 items-center justify-end">
                <CandidateSignInButton />
              </div>
            </Switch.Case>
          </Switch.Container>
        ) : null
      }
    />
  );
};

export const EmptyCareersPage = (props: {
  needsAgencyLogin?: boolean;
  showSignInButton?: boolean;
  userType?: SELF_APPLY_USER_TYPE_ENUM;
}) => {
  const router = useRouter();
  const autoSignInPrompt = router.query.autoSignInPrompt ?? "false";
  const org = useRouterVariable("org", (o) => o as string);

  useEffect(() => {
    if (autoSignInPrompt === "true") {
      openAgencyEmailSignInModal();
    }
  }, [autoSignInPrompt]);

  const orgName = useFetchOrgDisplayName(
    { orgFriendlyName: org },
    {
      query: {
        enabled: org != null,
      },
    },
  );

  const orgAtsEnabled = useFetchOrgAtsEnabled(
    {
      orgFriendlyName: org as string,
    },
    {
      query: {
        enabled: org != null,
      },
    },
  );

  return (
    <NoSidebar.Container>
      <NoSidebar.Header>
        <EmptySelfApplyHeader
          userType={props.userType}
          showSignInButton={props.showSignInButton}
        />
      </NoSidebar.Header>
      <NoSidebar.Content>
        {orgName?.data ? (
          <NoJobAvailable
            orgDisplayName={orgName.data}
            atsEnabled={orgAtsEnabled.data}
            needsSignin={props.needsAgencyLogin}
          />
        ) : null}
      </NoSidebar.Content>
    </NoSidebar.Container>
  );
};
